import api from "./api";

// 定制化数字人删除
export const actorDelete = async (id: string) => {
  const res = await api.post<unknown>("/actor/delete", { id });
  return res;
};
